<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 10 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1 1 8.03 6.578L1 14.154"
      stroke="#B2B2B2"
      fill="none"
      fill-rule="evenodd"
    />
  </svg>
</template>
